import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
//MUI icon
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { useAccess, FEATURES } from "../../../hooks/useAccess";

//pagination
import Pagination from "../../../pages/Pagination";

//Date Range Picker
import { DateRangePicker } from "react-date-range";
//Calendar Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import dayjs from "dayjs";
import { connect, useSelector } from "react-redux";
import { getGameHistory, getGameStats, resetGameCoin } from "../../../store/GameHistory/action";

const TeenPattiHistory = (props) => {
  const { gameHistory, pagination, gameStats } = useSelector(
    (state) => state.gameHistory
  );

  const { canView } = useAccess();

  const [data, setData] = useState([]);
  const [date, setDate] = useState([]);
  const [sDate, setsDate] = useState("ALL");
  const [eDate, seteDate] = useState("ALL");

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    props.getGameHistory(activePage, rowsPerPage, sDate, eDate);
    props.getGameStats(sDate, eDate);
  }, [activePage, rowsPerPage, sDate, eDate]);

  useEffect(() => {
    setData(gameHistory);
  }, [gameHistory]);

  useEffect(() => {
    $("#card").click(() => {
      $("#datePicker");
    });
  }, []);

  useEffect(() => {
    if (date.length === 0) {
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
    $("#datePicker");
    setData(gameHistory);
  }, [date, gameHistory]);

  const getAllUser = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker");
  };

  const collapsedDatePicker = () => {
    $("#datePicker").toggleClass("collapse");
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };


  const handleResetCoin = () => {
    props.resetGameCoin()
    handleRefresh();
  }

  const handleRefresh = () => {
    props.getGameHistory(activePage, rowsPerPage, sDate, eDate);
    props.getGameStats(sDate, eDate);
  }

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Teen Patti History</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Teen Patti History
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="row">
            {canView(FEATURES.GAME_TEEN_PATTI_SUMMARY_TOTAL_GAMES) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {gameStats?.totalGames || 0}
                      </h5>
                      <p className="stats-text">Total Games</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">videogame_asset</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_TEEN_PATTI_SUMMARY_DIAMOND_SPENT) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {gameStats?.totalDiamondsSpent?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">Total Diamonds Spent</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">monetization_on</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_TEEN_PATTI_SUMMARY_DIAMONDS_WON) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {gameStats?.totalDiamondsWon?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">Total Diamonds Won</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">stars</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_TEEN_PATTI_SUMMARY_HOUSE_PROFIT) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {gameStats?.houseProfit?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">House Profit (Diamonds)</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">trending_up</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                  <div className="text-left align-sm-left d-md-flex d-lg-flex justify-content-start">
                    {canView(FEATURES.GAME_TEEN_PATTI_ADMIN_DIAMONDS) && (
                      <button
                        className="btn btn-light text-info"
                        style={{ marginRight: 5 }}
                        onClick={handleResetCoin}
                      >
                        Reset Diamond
                      </button>
                    )}
                    <button
                      className="btn btn-info"
                      style={{ marginRight: 5 }}
                      onClick={getAllUser}
                    >
                      All
                    </button>
                    <button
                      className="btn btn-success"
                      style={{ marginRight: 5 }}
                      onClick={handleRefresh}
                    >
                      <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                    <button
                      className="collapsed btn btn-info ml-5"
                      value="check"
                      data-toggle="collapse"
                      data-target="#datePicker"
                      onClick={collapsedDatePicker}
                    >
                      Analytics
                      <ExpandMoreIcon />
                    </button>
                    <p style={{ paddingLeft: 10 }} className="my-2 ">
                      {sDate !== "ALL" && sDate + " to " + eDate}
                    </p>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right">
                  <div className="d-flex justify-content-end mt-3">
                    {canView(FEATURES.GAME_TEEN_PATTI_ADMIN_DIAMONDS) && (
                      <span className="text-danger me-5">
                        Admin Diamonds:
                        <span className="text-info">&nbsp;&nbsp;{gameStats?.adminCoin}</span>
                      </span>
                    )}
                    <span className="text-danger">
                      Total Records:
                      <span className="text-info">&nbsp;&nbsp;{pagination?.total || 0}</span>
                    </span>
                  </div>
                </div>
                <div
                  id="datePicker"
                  className="collapse mt-5 pt-5"
                  aria-expanded="false"
                >
                  <div className="container table-responsive">
                    <div key={JSON.stringify(date)}>
                      <DateRangePicker
                        onChange={(item) => {
                          setDate([item.selection]);
                          const dayStart = dayjs(
                            item.selection.startDate
                          ).format("YYYY-MM-DD");
                          const dayEnd = dayjs(item.selection.endDate).format(
                            "YYYY-MM-DD"
                          );
                          setActivePage(1);
                          setsDate(dayStart);
                          seteDate(dayEnd);
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={date}
                        direction="horizontal"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              <table className="table table-striped" style={{ borderCollapse: "collapse" }}>
                <thead className="text-center">
                  <tr>
                    <th>No</th>
                    <th>Diamonds Spent</th>
                    <th>Diamonds Won</th>
                    <th>House Profit</th>
                    <th>Winning Frame</th>
                    <th>Date</th>
                    <th>Info</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data?.length > 0 ? (
                    data?.map((record, index) => {
                      const recordDate = record?.date ? record.date.split(",")[0] : "";
                      const recordTime = record?.date ? record.date.split(",")[1] : "";
                      const diamondsWon = Math.abs(record?.winnerCoinMinus || 0);
                      const houseProfit = (record?.totalAdd || 0) - diamondsWon;

                      return (
                        <React.Fragment key={record._id}>
                          <tr
                            data-toggle="collapse"
                            data-target={`#demo${index}`}
                            className="accordion-toggle pointer-cursor"
                          >
                            <td>{(activePage - 1) * rowsPerPage + index + 1}</td>
                            <td className="text-warning">{record?.totalAdd?.toLocaleString()}</td>
                            <td className="text-success">{diamondsWon?.toLocaleString()}</td>
                            <td className={houseProfit >= 0 ? "text-success" : "text-danger"}>
                              {houseProfit?.toLocaleString()}
                            </td>
                            <td className="text-info">{(record?.winnerIndex || 0) + 1}</td>
                            <td>
                              <div className="text-info">{recordDate}</div>
                              <div className="text-muted" style={{ fontSize: "0.85em" }}>{recordTime}</div>
                            </td>
                            <td className="pointer-cursor">
                              <i className="fas fa-info-circle fa-lg text-primary"></i>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={7} className="hiddenRow">
                              <div
                                id={`demo${index}`}
                                className="accordian-body collapse"
                              >
                                <div className="p-3">
                                  <h6 className="text-danger mb-3">Card Details</h6>
                                  <div className="card bg-dark border border-secondary mb-3">
                                    <div className="card-body p-2">
                                      <table className="table table-sm table-borderless mb-0">
                                        <thead>
                                          <tr>
                                            <th className="text-white">No</th>
                                            <th className="text-white">Frame</th>
                                            <th className="text-white">Bet Amount</th>
                                            <th className="text-white">Card</th>
                                            <th className="text-white">Result</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {record?.cardCoin?.length > 0 ? (
                                            record.cardCoin.map((card, idx) => {
                                              return (
                                                <tr key={idx}>
                                                  <td className="text-white">{idx + 1}</td>
                                                  <td className={card?.winner ? "fw-bold text-success" : "text-white"}>
                                                    {card?.selectFrame}
                                                  </td>
                                                  <td className="text-warning">
                                                    {card?.bit?.toLocaleString()}
                                                  </td>
                                                  <td className="text-info">
                                                    {card?.card}
                                                  </td>
                                                  <td>
                                                    {card?.winner ? (
                                                      <i className="fas fa-check-circle text-success"></i>
                                                    ) : (
                                                      <i className="fas fa-times-circle text-danger"></i>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })
                                          ) : (
                                            <tr>
                                              <td colSpan={5} className="text-center text-white">
                                                No card details available
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>

                                  <h6 className="text-danger mb-3">Participants</h6>
                                  <div className="card bg-dark border border-secondary">
                                    <div className="card-body p-2">
                                      <table className="table table-sm table-borderless mb-0">
                                        <thead>
                                          <tr>
                                            <th className="text-white">No</th>
                                            <th className="text-white">User</th>
                                            <th className="text-white">Unique ID</th>
                                            {/* <th className="text-white">Balance</th> */}
                                            <th className="text-white">Spent</th>
                                            <th className="text-white">Won</th>
                                            <th className="text-white">Net</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {record?.participants?.length > 0 ? (
                                            record.participants.map((participant, idx) => {
                                              const netResult = (participant?.coinWon || 0) - (participant?.coinSpent || 0);
                                              return (
                                                <tr key={idx}>
                                                  <td className="text-white">{idx + 1}</td>
                                                  <td>
                                                    <div className="d-flex align-items-center">
                                                      <img
                                                        src={participant?.userId?.image}
                                                        alt={participant?.userId?.username}
                                                        style={{
                                                          width: "25px",
                                                          height: "25px",
                                                          borderRadius: "50%",
                                                          objectFit: "cover",
                                                          marginRight: "8px"
                                                        }}
                                                        onError={(e) => {
                                                          e.target.src = "https://devadmin.vibelynk.com/storage/male.png";
                                                        }}
                                                      />
                                                      <span className="text-white">{participant?.userId?.username}</span>
                                                    </div>
                                                  </td>
                                                  <td className="text-info">{participant?.userId?.uniqueId}</td>
                                                  {/* <td className="text-primary">
                                                    {participant?.userId?.diamond?.toLocaleString()}
                                                  </td> */}
                                                  <td className="text-danger">
                                                    {participant?.coinSpent?.toLocaleString()}
                                                  </td>
                                                  <td className="text-success">
                                                    {participant?.coinWon?.toLocaleString()}
                                                  </td>
                                                  <td className={netResult >= 0 ? "text-success fw-bold" : "text-danger fw-bold"}>
                                                    {netResult >= 0 ? "+" : ""}{netResult?.toLocaleString()}
                                                  </td>
                                                </tr>
                                              );
                                            })
                                          ) : (
                                            <tr>
                                              <td colSpan={7} className="text-center text-white">
                                                No participants available
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={pagination?.total || 0}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getGameHistory, getGameStats, resetGameCoin })(TeenPattiHistory);
